export default __webpack_public_path__ + "static/media/pic2.2f3589ab.jpg";